export default "__VITE_ASSET__DU$Nm24b__"